import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  box: {
    height: typography.pxToRem(90),
    width: typography.pxToRem(75),
  },
  title: {
    paddingTop: typography.pxToRem(40),
    height: typography.pxToRem(33),
    width: typography.pxToRem(220),
  },
  version: {
    paddingTop: typography.pxToRem(8),
    height: typography.pxToRem(25),
    width: typography.pxToRem(45),
  },
}));

const DPDIcon = () => {
  const styles = useStyles();

  return (
    <Box className={styles.container}>
      <SvgIcon viewBox="0 0 86 102" className={styles.box}>
        <path
          d="M83.5689 21.9143L82.3818 22.6679C73.7695 27.7317 65.1804 32.819 56.5448 37.8593C55.5195 38.3262 54.9152 39.4154 55.0551 40.5443C55.2181 43.559 55.0551 43.1821 57.5224 44.7366C58.3979 45.429 59.6188 45.4578 60.5251 44.8072C68.4391 40.0967 76.3997 35.3863 84.3137 30.6758L85.7569 29.8514C85.7744 30.1809 85.7744 30.5111 85.7569 30.8406V73.9652C85.7877 75.4285 84.9679 76.7742 83.662 77.4038L56.894 93.443C53.0068 95.7983 49.0963 98.1535 45.2557 100.509C43.8941 101.45 42.1017 101.45 40.7401 100.509C27.938 92.7836 15.1359 85.1212 2.33377 77.5216C0.828849 76.7497 -0.0839903 75.1518 0.00610824 73.447C0.00610824 59.3155 0.00610824 45.2547 0.00610824 31.2646C0.00610824 30.8406 0.00610824 30.4403 0.00610824 29.8514L1.28632 30.558L37.7141 51.9907C38.5438 52.3559 39.0432 53.2237 38.9478 54.134C38.9478 64.5913 38.9478 75.025 38.9478 85.4823V86.5422C38.9175 87.2404 39.3023 87.8893 39.9254 88.1908L41.8806 89.2978C42.4958 89.6749 43.2672 89.6749 43.8824 89.2978L45.7445 88.2615C46.4155 87.9705 46.8277 87.2784 46.7687 86.5422C46.7687 86.2596 46.7687 85.9769 46.7687 85.6943V50.1772C46.7687 49.8475 46.7687 49.5413 46.7687 49.2115C46.791 48.5651 46.4479 47.9621 45.8842 47.6571L42.9281 45.9142L3.54415 22.6679L2.33377 21.9378L3.31139 21.2548L40.5539 0.669951C41.9801 -0.223317 43.783 -0.223317 45.2092 0.669951C57.6621 7.59437 70.0685 14.401 82.4749 21.2548L83.5689 21.9143Z"
          fill="url(#paint0_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="0.0282983"
            y1="0"
            x2="0.0282983"
            y2="101.148"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DC0032" />
            <stop offset="0.2" stopColor="#D0012D" />
            <stop offset="0.4" stopColor="#C30229" />
            <stop offset="0.6" stopColor="#B70324" />
            <stop offset="0.8" stopColor="#AB041F" />
            <stop offset="1" stopColor="#9F041B" />
          </linearGradient>
        </defs>
      </SvgIcon>
      <SvgIcon viewBox="0 0 225 37" className={styles.title}>
        <path
          d="M14.7098 0.287842C23.1817 0.287842 29.5039 6.61753 29.5039 15.0993C29.5039 20.1564 27.176 24.461 23.4583 27.0369L20.563 24.0235C23.4095 22.1722 25.1626 18.934 25.1626 15.0993C25.1626 8.98062 20.8213 4.46544 14.7098 4.46544C8.72473 4.46544 4.29914 8.98062 4.29914 15.0993C4.29914 21.1336 8.72473 25.691 14.7098 25.691C15.3667 25.691 16.0032 25.6384 16.6161 25.5369L19.5147 28.9403L19.6284 28.9036L19.5147 28.9403C21.4459 30.5514 23.7611 33.0085 27.2668 33.2286L27.7758 33.2444C29.5882 33.2444 31.3163 32.9491 32.2436 32.5693L32.7494 36.1983C31.6535 36.5781 29.6725 37.0001 27.4808 37.0001C20.6527 37.0001 16.6908 30.7548 14.6677 29.8264C6.32227 29.7842 0 23.4967 0 15.0993C0 6.61753 6.32227 0.287842 14.7098 0.287842ZM40.1015 0.709828V17.2514C40.1015 22.3996 42.7147 25.7754 48.3205 25.7754C54.0105 25.7754 56.6659 22.1464 56.6659 17.2092V0.709828H61.0493V17.5468C61.0493 24.1719 56.708 29.8686 48.3205 29.8686C40.0172 29.8686 35.7181 24.7205 35.7181 17.5468V0.709828H40.1015ZM81.7834 0.783203L93.1664 29.4778H88.7397L86.2101 23.1481L79.2117 5.1718L71.8759 23.1481L69.2621 29.4778H64.8353L76.6821 0.783203H81.7834ZM102.686 29.4044V7.71468L120.895 29.4044H124.73V0.709828H120.347V22.484L102.139 0.709828H98.303V29.4044H102.686ZM145.022 29.4044V4.59204H154.8V0.709828H130.354V4.59204H140.638V29.4044H145.022ZM172.605 29.8686C180.993 29.8686 185.334 24.1719 185.334 17.5468V0.709828H180.951V17.2092C180.951 22.1464 178.295 25.7754 172.605 25.7754C167 25.7754 164.386 22.3996 164.386 17.2514V0.709828H160.003V17.5468C160.003 24.7205 164.302 29.8686 172.605 29.8686ZM197.828 29.4044V7.67249L208.618 20.7539H209.504L220.336 7.67249V29.4044H224.719V0.709828H220.715L209.082 14.7617L197.407 0.709828H193.445V29.4044H197.828Z"
          fill="#414042"
        />
      </SvgIcon>
      <SvgIcon viewBox="0 0 48 26" className={styles.version}>
        <path
          d="M0.660156 8.06641V8.09961H4.17969V8.0498C4.17969 5.55957 6.15527 3.66699 8.77832 3.66699C11.2686 3.66699 13.1943 5.36035 13.1943 7.48535C13.1943 9.36133 12.4307 10.623 9.50879 13.6611L0.859375 22.4766V25H17.2451V21.8623H5.87305V21.7793L11.8662 15.7529C15.3691 12.167 16.8633 10.0918 16.8633 7.30273C16.8633 3.50098 13.46 0.595703 8.89453 0.595703C4.12988 0.595703 0.660156 3.75 0.660156 8.06641Z"
          fill="#414042"
        />
        <path
          d="M23.1553 25.1826C24.3672 25.1826 25.3301 24.2197 25.3301 23.0078C25.3301 21.7959 24.3672 20.833 23.1553 20.833C21.9434 20.833 20.9805 21.7959 20.9805 23.0078C20.9805 24.2197 21.9434 25.1826 23.1553 25.1826Z"
          fill="#414042"
        />
        <path
          d="M38.0137 25.4482C43.7578 25.4482 47.1279 20.6172 47.1279 12.9805C47.1279 5.39355 43.7412 0.595703 38.0137 0.595703C32.3027 0.595703 28.8662 5.41016 28.8662 12.9971C28.8662 20.6338 32.2695 25.4482 38.0137 25.4482ZM38.0137 22.3271C34.5938 22.3271 32.6348 18.7744 32.6348 12.9971C32.6348 7.30273 34.627 3.7168 38.0137 3.7168C41.4004 3.7168 43.376 7.28613 43.376 12.9971C43.376 18.791 41.4336 22.3271 38.0137 22.3271Z"
          fill="#414042"
        />
      </SvgIcon>
    </Box>
  );
};

export default memo(DPDIcon);
